<template>
  <div>
    <h3>
      <label
        ><b> Hi {{ name }}.</b></label
      >
    </h3>
    <br />

    <div class="row">
      <div class="col-md-4 col-xl-4" @click="onClick('/stockout_user')">
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-warning`"
            slot="header"
          >
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Stockout</p>
          </div>
        </stats-card>
      </div>

      <div
        class="col-md-4 col-xl-4"
        @click="onClick('/purchase_order_user')"
        v-if="accLvl == 2"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-success`"
            slot="header"
          >
            <i class="ti-credit-card"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Purchase Order</p>
          </div>
        </stats-card>
      </div>

      <div
        class="col-md-4 col-xl-4"
        @click="onClick('/delivery_order_user')"
        v-if="accLvl == 2"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-danger`"
            slot="header"
          >
            <i class="ti-export"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Delivery Order</p>
          </div>
        </stats-card>
      </div>

      <div
        class="col-md-4 col-xl-4"
        @click="onClick('/mf_user')"
        v-if="accLvl == 2"
      >
        <stats-card>
          <div class="icon-big text-center" :class="`icon-info`" slot="header">
            <i class="ti-menu"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Monthly Forecast</p>
          </div>
        </stats-card>
      </div>

      <!-- <div class="col-md-4 col-xl-4" @click="onClick('/stockout_changes_user')">
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-warning`"
            slot="header"
          >
            <i class="ti-loop"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Amend Changes</p>
          </div>
        </stats-card>
      </div> -->

      <div
        class="col-md-4 col-xl-4"
        @click="onClick('/sub_dealer_user')"
        v-if="accLvl == 2 || accLvl == 3"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-success`"
            slot="header"
          >
            <i class="ti-user"></i>
          </div>
          <div class="numbers" slot="content">
            <p v-if="accLvl == 2">Home Dealer</p>
            <p v-if="accLvl == 3">Agent</p>
          </div>
        </stats-card>
      </div>

      <div
        class="col-md-4 col-xl-4"
        @click="onClick('/outlet_history_name_user')"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-success`"
            slot="header"
          >
            <i class="ti-book"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Outlet Name History</p>
          </div>
        </stats-card>
      </div>
    </div>
    <b-card>
      <h5><b> LIST OF NOTIFICATIONS</b></h5>
      <hr />
      <b-table
        show-empty
        head-variant="dark"
        striped
        hover
        bordered
        :items="items"
        :fields="fields"
        id="my-table"
        :per-page="perPage"
        :current-page="currentPage"
      >
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card>

    <first-time-modal @close="onFTModal($event)" />
  </div>
</template>
<script>
import { StatsCard } from "@/components/index";
import { FirstTimeModal } from "@/components/index";

export default {
  components: {
    StatsCard,
    FirstTimeModal
  },
  data() {
    return {
      form: {
        mesej: ""
      },

      perPage: 10,
      currentPage: 1,
      filter: null,
      filterOn: [],
      totalRows: 1,

      items: [],

      fields: [
        {
          label: "Notifications",
          key: "mesej",
          sortable: false
        }
      ],

      // Name
      name: "",
      firstTime: false,
      accLvl: null
    };
  },
  created() {
    this.getNotiUser();
    this.getUserData();
    this.accLvl = this.$store.getters.getAccessLevel;
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    rows() {
      return this.items.length;
    }
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },

  methods: {
    onClick(path) {
      this.$router.push({ path: path });
    },
    getNotiUser() {
      this.$store.dispatch("getNotiUser").then(res => {
        if (res.data.response.code === 100) {
          this.items = [];

          res.data.data.forEach(element => {
            this.items.push({
              mesej:
                element.message + " - " + element.date + " - " + element.time,
              date: element.date,
              time: element.time
            });
          });
        }
      });
    },

    // Get User Data
    getUserData() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$store.getters.getUser_id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.name = res.data.data.name;
            this.firstTime = res.data.data.first_password;
          }
          this.showFirstTime();
        });
    },

    // Show Modal
    showFirstTime() {
      if (this.firstTime === true) {
        this.$bvModal.show("first-time");
      }
    },

    onFTModal(response) {
      if (response === "success") {
        this.$bvModal.hide("first-time");
      }
    }
  }
};
</script>
<style></style>
